import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Brand } from "@/components/Brand";
import { Button } from "@/components/ui/button";
import { Loader2, CheckCircle2, Clock } from "lucide-react";
import { EnterAfterPurchase } from "@/components/EnterAfterPurchase";

export default function PaymentResult() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [status, setStatus] = useState("checking");
  const [kind, setKind] = useState("");

  useEffect(() => {
    const orderId = params.get("external_reference");
    if (!orderId) { setStatus("pending"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const r = await api.get(user ? `/payments/order/${orderId}` : `/public/sale/order/${orderId}`);
        if (r.data.kind) setKind(r.data.kind);
        if (r.data.status === "approved") { setStatus("approved"); return; }
      } catch (e) {}
      if (++tries < 10) setTimeout(poll, 3000);
      else setStatus("pending");
    };
    poll();
  }, [params]);

  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <header className="h-16 border-b border-slate-200 bg-white flex items-center px-6"><Brand size="md" /></header>
      <main className="max-w-md mx-auto px-5 py-20 text-center">
        {status === "checking" && (
          <><Loader2 className="h-12 w-12 animate-spin text-[#232D4F] mx-auto" /><p className="text-slate-500 mt-4">Confirmando seu pagamento...</p></>
        )}
        {status === "approved" && (
          <div className="animate-fade-up">
            <CheckCircle2 className="h-16 w-16 text-[#1E9E2A] mx-auto" />
            <h1 className="font-display text-2xl font-bold text-slate-900 mt-4">Pagamento aprovado!</h1>
            {user && kind === "ia_creditos" ? (<><p className="text-slate-500 mt-2">Suas perguntas da IEP Intelligence já estão disponíveis. Bons estudos!</p>
            <Button onClick={() => navigate("/app")} className="mt-6 text-white" style={{ background: "#232D4F" }}>Voltar para a plataforma</Button></>) : user ? (<><p className="text-slate-500 mt-2">Sua matrícula foi liberada. Bons estudos!</p>
            <Button data-testid="go-to-courses" onClick={() => navigate("/app")} className="mt-6 text-white" style={{ background: "#232D4F" }}>Ir para meus cursos</Button></>) : (<><p className="text-slate-500 mt-2 mb-6">Sua matrícula está garantida. Agora crie sua senha para entrar na plataforma. A nota fiscal chega por e-mail.</p>
            <EnterAfterPurchase orderId={params.get("external_reference")} /></>)}
          </div>
        )}
        {status === "pending" && (
          <div className="animate-fade-up">
            <Clock className="h-16 w-16 text-orange-500 mx-auto" />
            <h1 className="font-display text-2xl font-bold text-slate-900 mt-4">Pagamento em processamento</h1>
            <p className="text-slate-500 mt-2">Assim que for aprovado, sua matrícula será liberada automaticamente.</p>
            <Button onClick={() => navigate(user ? "/app" : "/login")} variant="outline" className="mt-6">{user ? "Voltar aos cursos" : "Ir para o login"}</Button>
          </div>
        )}
      </main>
    </div>
  );
}
